import { render } from "./CostQuery.vue?vue&type=template&id=151a7b79&scoped=true"
import script from "./CostQuery.vue?vue&type=script&lang=js"
export * from "./CostQuery.vue?vue&type=script&lang=js"

import "./CostQuery.vue?vue&type=style&index=0&id=151a7b79&lang=less&scoped=true"

import exportComponent from "/root/workspace/school-mobile_yvTP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151a7b79"]])

export default __exports__